import React, { Fragment, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Helmet } from "react-helmet";
import swal from "sweetalert";
import CloseIcon from "@mui/icons-material/Close";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./search.css";

// icons

import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import Loader from "../../layout/loader";
import { directBuyAction } from "../../redux/actions/directBuyAction";
import fallbackProductImage from "../../images/not_found_product.png";

const safeText = (value, fallback = "") => {
  if (value === null || value === undefined) return fallback;
  if (typeof value === "string" || typeof value === "number")
    return String(value);
  return fallback;
};

const safeNumber = (value, fallback = 0) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : fallback;
};

const safeArray = (value) => (Array.isArray(value) ? value : []);

const trimText = (value, limit = 42) => {
  const text = safeText(value);
  return text.length > limit ? `${text.slice(0, limit)}...` : text;
};

const firstProductImage = (product) => {
  const mainImage = safeArray(product?.mainImage)[0];
  return safeText(mainImage?.imageurl);
};

const SearchRatingStars = ({ value }) => {
  const rating = Math.max(0, Math.min(5, Math.round(safeNumber(value))));

  return (
    <div
      className="search-rating-stars"
      aria-label={`${rating} out of 5 rating`}
    >
      {[1, 2, 3, 4, 5].map((star) => (
        <span key={star} className={star <= rating ? "active" : ""}>
          ★
        </span>
      ))}
    </div>
  );
};

function SearchedProduct({ loading, currentItems }) {
  const history = useHistory();
  const dispatch = useDispatch();

  const { isAuthenticated } = useSelector((state) => state.user);

  const [selectedImages, setSelectedImages] = useState({});

  const [buyNowButtonClick, setBuyNowButtonClick] = useState(false);
  const [seletedProductId, setSelectedProductId] = useState();
  const [selectBox, setSelectBox] = useState("");
  const [colour, setColour] = useState("");
  const [size, setSize] = useState("");

  const productHandler = (urlPart) => {
    history.push(`/ProductDetail/${urlPart}`);
  };

  const imageSelectHandler = (productUrl, productId) => {
    setSelectedImages((prev) => ({
      ...prev,
      [productId]: productUrl,
    }));
  };

  const buyNowHandler = (id) => {
    if (!id) {
      return swal({
        title: "Validation Info",
        text: "Invalid..!!",
        icon: "info",
      });
    }

    setSelectedProductId(id);
    setBuyNowButtonClick(true);
  };

  // buy button handler

  const bestSellerBuyNowHanlder = (e) => {
    e.preventDefault();

    if (!size || !colour) {
      return swal({
        title: "Validation Error",
        text: "Please Select Colour and Size..!!",
        icon: "info",
      });
    }

    if (!selectBox) {
      return swal({
        title: "Validation Error",
        text: "Please Select Box !!",
        icon: "info",
      });
    }
    // by defalut it will be one
    const quantity = 1;

    dispatch(
      directBuyAction(seletedProductId, quantity, size, colour, selectBox)
    );

    if (!isAuthenticated) {
      swal({
        title: "Validation Error",
        text: "Please Login..!!",
        icon: "info",
      });
    }

    history.push("/Login?redirect=/Checkout/directbuy");
  };

  //    button close function

  const closeBestSellerBuyNowButton = () => {
    setBuyNowButtonClick(false);
    setSelectedProductId("");
  };

  return (
    <Fragment>
      {loading ? (
        <Loader />
      ) : (
        <Fragment>
          {currentItems &&
            currentItems.map((pro, index) => {
              const productId = safeText(pro?._id, index);
              const productName = safeText(pro?.name, "Product");
              const productTag = safeText(
                pro?.tag || pro?.brandName || pro?.category,
                "Available now"
              );
              const selectedImage = selectedImages[productId];
              const displayImage = selectedImage || firstProductImage(pro);
              const productImages = safeArray(pro?.image);
              const productRating = safeNumber(pro?.ratings);
              const productPrice = safeNumber(pro?.price);
              const productStock = safeNumber(
                pro?.productStock ?? pro?.Stock,
                null
              );

              const productUrl = `https://imonline.shop/ProductDetail/${
                pro.slug || productId
              }`;

              return (
                <article className="search-product-card" key={productId}>
                  <Helmet>
                    <script type="application/ld+json">{`
                            [
                                {
                                    "@context": "https://schema.org",
                                    "@type": "Product",
                                    "name": "${productName}",
                                    "image": "${displayImage}",
                                    "description": "${safeText(
                                      pro?.discription
                                    ).replace(/"/g, '\\"')}",
                                    "brand": {
                                        "@type": "Brand",
                                        "name": "${safeText(
                                          pro?.brandName || pro?.category,
                                          "IM Online"
                                        )}"
                                    },
                                    "sku": "${productId}",
                                    "offers": {
                                        "@type": "Offer",
                                        "url": "${productUrl}",
                                        "priceCurrency": "INR",
                                        "price": "${productPrice}",
                                        "availability": "${
                                          productStock > 0
                                            ? "https://schema.org/InStock"
                                            : "https://schema.org/OutOfStock"
                                        }",
                                        "itemCondition": "https://schema.org/NewCondition"
                                    }${
                                      productRating > 0 &&
                                      safeNumber(pro?.numOfReviews, 0) > 0
                                        ? `,"aggregateRating": {
                                        "@type": "AggregateRating",
                                        "ratingValue": "${productRating}",
                                        "reviewCount": "${safeNumber(
                                          pro?.numOfReviews,
                                          0
                                        )}"
                                    }`
                                        : ""
                                    }}
                                },
                                {
                                    "@context": "https://schema.org",
                                    "@type": "BreadcrumbList",
                                    "itemListElement": [{
                                        "@type": "ListItem",
                                        "position": 1,
                                        "name": "Home",
                                        "item": "https://imonline.shop/"
                                    },{
                                        "@type": "ListItem",
                                        "position": 2,
                                        "name": "Search",
                                        "item": "https://imonline.shop/find/shoes"
                                    },{
                                        "@type": "ListItem",
                                        "position": 3,
                                        "name": "${productName}"
                                    }]
                                }
                            ]`}</script>
                  </Helmet>
                  <Link
                    to={`/ProductDetail/${pro.slug || productId}`}
                    className="search-product-image"
                  >
                    {displayImage ? (
                      <img
                        src={displayImage}
                        alt={productName}
                        onError={(event) => {
                          event.currentTarget.onerror = null;
                          event.currentTarget.src = fallbackProductImage;
                        }}
                      />
                    ) : (
                      <span>No image</span>
                    )}
                  </Link>

                  {productImages.length > 0 && (
                    <div className="search-product-thumbs">
                      {productImages.slice(0, 4).map((newImage, imageIndex) => {
                        const thumbUrl = safeText(newImage?.imageurl);
                        if (!thumbUrl) return null;

                        return (
                          <button
                            type="button"
                            onClick={() =>
                              imageSelectHandler(thumbUrl, productId)
                            }
                            className={
                              selectedImages[productId] === thumbUrl
                                ? "active"
                                : ""
                            }
                            aria-label={`Preview ${productName}`}
                            key={safeText(newImage?.public_id, imageIndex)}
                          >
                            <img
                              src={thumbUrl}
                              alt={productName}
                              onError={(event) => {
                                event.currentTarget.onerror = null;
                                event.currentTarget.src = fallbackProductImage;
                              }}
                            />
                          </button>
                        );
                      })}
                    </div>
                  )}

                  <div className="search-product-body">
                    <span className="search-product-tag">{productTag}</span>
                    <Link
                      to={`/ProductDetail/${pro.slug || productId}`}
                      className="search-product-name"
                    >
                      {trimText(productName)}
                    </Link>

                    <div className="search-product-rating">
                      <SearchRatingStars value={productRating} />
                      <span>
                        {productRating ? `${productRating}/5` : "New"}
                      </span>
                    </div>

                    <div className="search-product-meta">
                      <strong>
                        <CurrencyRupeeIcon />
                        {productPrice}
                      </strong>
                      {productStock !== null && (
                        <span>
                          {productStock > 0
                            ? `${productStock} in stock`
                            : "Out of stock"}
                        </span>
                      )}
                    </div>

                    <div className="searched-product-buttons-style">
                      <button
                        className="searched-product-buy-now-button-style"
                        onClick={() => buyNowHandler(productId)}
                        type="button"
                      >
                        <ShoppingCartIcon /> Buy now
                      </button>
                      <button
                        className="searched-product-view-button-style"
                        onClick={() => productHandler(pro.slug || productId)}
                        type="button"
                      >
                        <VisibilityOutlinedIcon />
                      </button>
                    </div>
                  </div>

                  {buyNowButtonClick !== false &&
                  seletedProductId === productId ? (
                    <>
                      <div className="buy-now-main-container">
                        <div className="buy-now-second-conatiner-close-div">
                          <button onClick={closeBestSellerBuyNowButton}>
                            {" "}
                            <CloseIcon />{" "}
                          </button>
                        </div>
                        <div className="buy-now-second-container search-buy-now-panel">
                          <div className="buy-now-third-container">
                            <h2 className="heading-for-buy-now">
                              Select Options
                            </h2>
                          </div>
                          <form onSubmit={bestSellerBuyNowHanlder}>
                            {/**SIZE BUTTON */}
                            <div className="buy-now-size-detail-div">
                              <span>
                                <label className="">Sizes</label>
                                <select
                                  onChange={(e) => setSize(e.target.value)}
                                >
                                  <option value="">Select Size</option>
                                  {safeArray(pro?.sizeOfShoes).map(
                                    (sizes, index) => (
                                      <option
                                        value={safeText(sizes)}
                                        key={index}
                                      >
                                        {safeText(sizes)}
                                      </option>
                                    )
                                  )}
                                </select>
                              </span>
                            </div>
                            {/**COLOUR BUTTON */}
                            <div className="buy-now-colour-detail-div">
                              <span>
                                <label className="">Colours </label>
                                <select
                                  onChange={(e) => setColour(e.target.value)}
                                >
                                  <option value="">Select Colour</option>
                                  {safeArray(pro?.colorOfShoes).map(
                                    (catagery, index) => (
                                      <option
                                        value={safeText(catagery)}
                                        key={index}
                                      >
                                        {safeText(catagery)}
                                      </option>
                                    )
                                  )}
                                </select>
                              </span>
                            </div>

                            {/**Box BUTTON */}
                            <div className="buy-now-colour-detail-div">
                              <span>
                                <label className="">Box Type </label>
                                <select
                                  onChange={(e) => setSelectBox(e.target.value)}
                                >
                                  <option value="">
                                    Select Packaging Type
                                  </option>
                                  <option value="0"> Default-Packing</option>
                                  <option value="50">Simple-Box 50₹</option>
                                  <option value="150">Original-Box 150₹</option>
                                </select>
                              </span>
                            </div>
                            <div className="buy-now-container-btn-div">
                              <input type="submit" value="Buy Now" />
                            </div>
                          </form>
                        </div>
                      </div>
                    </>
                  ) : null}
                </article>
              );
            })}
        </Fragment>
      )}
    </Fragment>
  );
}

export default SearchedProduct;
